export function api(endpoint: string): string {
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  const fullUrl = `${baseUrl}${endpoint}`;
  console.log(
    `%c[API] ${fullUrl}`,
    'color: #0a84ff; font-weight: bold',
    `(REACT_APP_API_URL=${process.env.REACT_APP_API_URL || '(unset, using default)'})`
  );
  return fullUrl;
}
